import React, { CSSProperties } from 'react';
import { Draggable, Droppable, DragDropContext, OnDragEndResponder } from 'react-beautiful-dnd';
import { clsx, deepCopy, makeKey, styx } from "modules/Utils";

interface DraggableListProps {
    className?: string;
    style?: CSSProperties;
    id?: string;
    list: any[];
    keyOfItem: string;
    renderItem: (item: any, index: number, dragHandleProps?: any) => React.ReactNode;
    updateList: (newList: any) => void;
    onDragEnd?: OnDragEndResponder;
    isDragHandle?: boolean;
    isGap?: boolean;
}

export const DraggableList = ({
    className,
    style,
    id = 'draggable-list',
    list,
    keyOfItem,
    updateList,
    onDragEnd,
    renderItem,
    isDragHandle = false,
    isGap = true,
}: DraggableListProps) => {
    const defaultDragEnd: OnDragEndResponder = (result) => {
        const sourceIndex = result.source.index;
        const destinationIndex = result.destination?.index;

        if (!destinationIndex && destinationIndex !== 0) {
            return;
        }

        const tempList = deepCopy(list);
        const temp = tempList[sourceIndex];
        tempList[sourceIndex] = tempList[destinationIndex];
        tempList[destinationIndex] = temp;

        updateList(tempList)
    };

    return (
        <DragDropContext onDragEnd={onDragEnd || defaultDragEnd}>
            <Droppable droppableId={id}>
                {(provided) => {
                    return (
                        <div
                            className={clsx('draggableListContainer', className)}
                            style={styx(
                                sty.draggableListContainer,
                                isGap ? { gap: 8 } : { gap: 0 },
                                style
                            )}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {list.map((item, index) => (
                                <Draggable
                                    key={makeKey(id, item[keyOfItem], index)}
                                    draggableId={makeKey(id, item[keyOfItem], index)}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div
                                            {...provided.draggableProps}
                                            {...(isDragHandle ? {} : provided.dragHandleProps)}
                                            ref={provided.innerRef}
                                        >
                                            {isDragHandle ?
                                                renderItem(item, index, provided.dragHandleProps)
                                                :
                                                renderItem(item, index)
                                            }
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )
                }}
            </Droppable>
        </DragDropContext>
    );
};

const sty: Record<string, CSSProperties> = {
    draggableListContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    }
}